import { Layout } from "../components/Layout";
import { Hero } from "../components/Hero";
import { Contact } from "../components/Contact";
import { Seo } from "../components/Seo";
import {
  TrustedBy, AboutIntro, Numbers, ServicesShowcase, NorbitShowcase, IndustriesGrid,
  PortfolioGrid, CaseStudiesPreview, ProcessSteps, TechMarquee, WhyChoose,
  Testimonials, BlogsPreview, FAQ,
} from "../components/Sections";
import { FAQS, TAGLINE, COMPANY_CORE_THOUGHT, LEGAL_ENTITY, SOCIAL_LINKS } from "../data";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "url": "https://neuravolt.in",
    "slogan": TAGLINE,
    "logo": "https://neuravolt.in/assets/logo.png",
    "description": COMPANY_CORE_THOUGHT,
    "foundingDate": "2024",
    "email": "info@neuravolt.in",
    "telephone": "+919202243725",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "E Block, 511, Amity Innovation Center",
      "addressLocality": "Gwalior",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "474020",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 26.2183,
      "longitude": 78.1828
    },
    "sameAs": [
      SOCIAL_LINKS.linkedin,
      SOCIAL_LINKS.linkedin_profile,
      SOCIAL_LINKS.instagram,
      SOCIAL_LINKS.github,
      SOCIAL_LINKS.google_maps,
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "telephone": "+919202243725",
      "email": "info@neuravolt.in",
      "url": "https://neuravolt.in/contact",
      "availableLanguage": ["English", "Hindi"]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Neuravolt",
    "url": "https://neuravolt.in"
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  }
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title=""
        description="Neuravolt (VOLTNOVATE SOLUTIONS LLP) is an AI-first software engineering company in India. We build custom AI solutions, web & mobile apps, cloud infrastructure, ERP, CRM, HRMS, and enterprise platforms. Get a free consultation today."
        keywords="Neuravolt, AI development company, custom software development India, web development, mobile app development, cloud DevOps, ERP software, CRM, HRMS, AI automation, VOLTNOVATE SOLUTIONS LLP, Gwalior, software company India"
        path="/"
        jsonLd={jsonLd}
      />
      {/* 1 & 2. Hero Fold */}
      <Hero />
      {/* 3. Trusted by Businesses Across the Globe */}
      <TrustedBy />
      {/* 4. Who we are? */}
      <AboutIntro />
      <Numbers />
      {/* 5. What we do? Services & Products Engineered for Scale */}
      <ServicesShowcase />
      {/* 6. Who we've worked for? */}
      <IndustriesGrid />
      {/* 7. What We've Built */}
      <PortfolioGrid isHome={true} />
      {/* 8. How do We Operate? */}
      <ProcessSteps />
      {/* 9. What Fuels Our Services (Our Stack Section) */}
      <TechMarquee />
      {/* 10. Real Work, Real Stories (Case Studies) */}
      <CaseStudiesPreview />
      {/* 11. Why Choose Us? */}
      <WhyChoose />
      {/* 12. What Do Our Clients Say? */}
      <Testimonials />
      {/* 13. Blog preview */}
      <BlogsPreview />
      {/* 14. FAQ */}
      <FAQ />
      {/* 15. Contact (single callout, duplicate CTA removed) */}
      <Contact />
    </Layout>
  );
}
